module.exports = __webpack_public_path__ + "static/Abacus Data Analyser HR Dashboard HR Kennzahlen-e8b8adce333ca97e2427416a6d96ebb0.jpg";